<template>
    <div id="app">
        <div class="doc-layout">
            <div class="doc-header"
                 ref="docHeader">
                <div class="doc-logo">
                    <img :src="logo"
                         @click="goHome"
                         width="135px">
                </div>
                <div class="doc-menu">
                    <topMenu @getDocHeaderWith="getDocHeaderWith">
                    </topMenu>
                </div>
                <div class="doc-operator">
                    <!-- <span class="">
                        <a-icon type="phone"
                                style="transform: rotate(90deg)" />&nbsp;{{contactNumber}}
                    </span> -->
                    <span class="login"
                          v-if="!currentName">
                        <span class="login-button">
                            <a href="https://cmp.cdxccloud.com">{{'登录'}}</a>
                        </span>
                    </span>
                    <div v-else>
                        <a-button class="console-button">
                            <a href="https://cmp.cdxccloud.com/?console=true"> 控制台</a>
                        </a-button>
                        <a-button type="link"
                                  class="link-button"><a href="https://cmp.cdxccloud.com/?console=true">{{currentName}}</a></a-button>
                    </div>
                </div>
            </div>
            <div class="doc-container">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
import topMenu from '@/views/components/top-menu.vue'

export default {
    name: 'App',
    components: {
        topMenu
    },
    data () {
        return {
            logo: null,
            favicon: null,
            contactNumber: null,
            isDevelop: true,
            hasCookie: ''
        }
    },
    computed: {
        currentName () {
            return this.$store.state.user.currentName
        }
    },
    created () {
        this.isDevelop = (process.env.NODE_ENV === 'development') // 是否是开发环境
        this.$store.commit('setRestUrl')
        this.initApp()
        this.getCookie('currentName')
    },
    methods: {
        initApp () {
            const protocol = window.location.protocol
            const hostName = window.location.hostname
            const port = window.location.port
            const restUrl = protocol + '//' + hostName + ':' + port
            this.favicon = require('./assets/img/favicon.png')
            localStorage.setItem('favicon', this.favicon)
            const ary = ['system.name', 'company.name', 'platform.small.logo', 'platform.large.logo', 'system.contact.number']
            fetch(restUrl + '/api/v1/sys_config/config_data?configKeys=' + ary.join(',')).then(response => {
                return response.json()
            }).then(result => {
                const resultData = result.data || []
                resultData.forEach(item => {
                    switch (item.configKey) {
                        case 'platform.large.logo':
                            this.logo = item.configValue || '/static/img/logos/logo.png'
                            break
                        case 'platform.small.logo':
                            localStorage.setItem('favicon', item.configValue || './static/img/logos/favicon.png')
                            this.favicon = item.configValue || './static/img/logos/favicon.png'
                            break
                        case 'system.contact.number':
                            this.contactNumber = item.configValue || '400-000-8888'
                            break
                    }
                })
            }).catch(() => {
                this.logo = require('./assets/img/logo.png')
                this.favicon = './assets/img/favicon.png'
                // this.favicon = require('./assets/img/favicon.png')
                localStorage.setItem('favicon', this.favicon)
                this.contactNumber = '400-000-8888'
            })
        },
        goHome () {
            window.location.href = 'https://portal.cdxccloud.com/'
        },
        getDocHeaderWith () {
            const docWidth = this.$refs.docHeader
            return docWidth
        },
        getCookie (keyName) {
            const arrstr = document.cookie.split('; ')
            const user = {}
            for (var i = 0; i < arrstr.length; i++) {
                const temp = arrstr[i].split('=')
                if (temp[0] === 'currentName') {
                    user[temp[0]] = decodeURIComponent(temp[1])
                } else {
                    user[temp[0]] = temp[1]
                }
            }
            this.$store.commit('setUser', user)
        }
    }
}
</script>
<style lang="less" scoped>
#app {
    width: 100%;
    height: 100%;
    font-family: '微软雅黑', 'PingFang SC', 'Helvetica Neue', 'Microsoft YaHei', Helvetica, 'Hiragino Sans GB', Arial,
        sans-serif;
    color: #333;
    .doc-layout {
        width: 100%;
        height: 100%;
        overflow: hidden;
        .doc-header {
            width: 100%;
            height: 68px;
            // position: fixed;
            // top: 0px;
            z-index: 100000;
            // padding: 0 0 0 30px;
            // background: #144480;
            // overflow: hidden;
            background: #ffffff;
            border-bottom: 1px solid #e4e6f3;
            display: flex;
            .doc-logo {
                padding-left: 30px;
                width: 180px;
                height: 68px;
                line-height: 68px;
                img {
                    cursor: pointer;
                }
            }
            .doc-menu {
                width: calc(~'80% - 180px');
                padding-left: 70px;
                height: 68px;
                line-height: 68px;
            }
            .doc-operator {
                // width: calc(~'100% - 150px');
                // width: 150px;
                width: 20%;
                height: 68px;
                line-height: 68px;
                // color: #fff;
                text-align: right;
                .login {
                    width: 88px;
                    text-align: center;
                    display: inline-block;
                    background: #c7000a;
                    color: #fff;
                    // margin-right: -20px;
                    span {
                        cursor: pointer;
                    }
                }
                .console-button {
                    color: #c7000a;
                    border: 1px solid #c7000a;
                    border-radius: 5px;
                }
                .link-button {
                    color: #c7000a;
                }
                .login-button {
                    color: #fff;
                    a {
                        color: #fff;
                        font-size: 14px;
                        font-weight: 400;
                    }
                }
            }
        }
        .doc-container {
            // margin-top: 68px;
            width: 100%;
            height: calc(~'100% - 68px');
            // height: calc(~'100% - 56px');
        }
    }
}
</style>
